const A = ["#6FA2CE"], _ = [...A, "#036840"], o = [..._, "#A9660F"], t = [..._, "#90C40E", o[2]];
export {
  A as POI_6_TA1,
  _ as POI_6_TA2,
  o as POI_6_TA3,
  t as POI_6_TA4
};
//# sourceMappingURL=index.es5719.js.map
